"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash.uniqueid"));

var _lodash2 = _interopRequireDefault(require("lodash.random"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RANDOM_RANGE = 1000;

function _default() {
  return (0, _lodash.default)("co-".concat((0, _lodash2.default)(RANDOM_RANGE), "-"));
}